import React from 'react'
import '../assets/css/hero.css';
import ProfileImg from '../assets/media/profileImg.jpg';
import Badge from './Badge';
function Hero() {
  return (
    <>
    <div id='hero-sec'>
         {/* <div className="hero-img">
        <img src={ProfileImg} alt="hero-img" />
        </div> */}
      <div className="hero-con">
      {/* <Badge title="Let's meet!"/> */}
       <h2>I'm Dilip Suthar</h2>
       <h2>Full Stack Developer </h2>
       <h2>And Freelancer</h2>

       <div className="hero-btn">
          <button>
            My Work
          </button>
          <button>
            Download My CV
          </button>
       </div>
      </div>

   
    </div>
   
      
        {/* icon with name */}
        <div className="hero-slider">
          <span>
            <i className="fa-brands fa-html5"></i>
            <p>HTML</p>
          </span>
          <span>
            <i className="fa-brands fa-css3-alt"></i>
            <p>CSS</p>
          </span>
          <span>
            <i className="fa-brands fa-js"></i>
            <p>JavaScript</p>
          </span>
          <span>
            <i className="fa-brands fa-react"></i>
            <p>React</p>
          </span>
          <span>
            <i className="fa-brands fa-node-js"></i>
            <p>Node.js</p>
          </span>
          <span>
            <i className="fa-brands fa-git-alt"></i>
            <p>Git</p>
          </span>
          <span>
            <i className="fa-brands fa-github"></i>
            <p>GitHub</p>
          </span>
          <span>
            <i className="fa-brands fa-figma"></i>
            <p>Figma</p>
          </span>
          <span>
            <i className="fa-brands fa-bootstrap"></i>
            <p>Bootstrap</p>
          </span>
      </div>
  
    </>
  )
}

export default Hero
